export const ptTranslations = {
  "site.name": "CSSBuyBR",
  "site.tagline": "Recurso independente para CSSBuy Spreadsheet",
  "nav.spreadsheet": "CSSBuy Spreadsheet",
  "nav.home": "Início",
  "nav.shoppingGuide": "Guia de Compras",
  "nav.guides": "Guias",
  "nav.reviews": "Reviews",
  "nav.shipping": "Envio",
  "nav.qc": "QC",
  "nav.sellers": "Vendedores",
  "nav.safety": "Segurança",
  "lang.pt": "PT-BR",
  "lang.de": "DE",
  "lang.en": "EN",
  "hero.title": "CSSBuy Spreadsheet: encontre produtos, vendedores e recursos de compra com mais facilidade",
  "hero.subtitle": "Explore um guia independente e atualizado para pesquisar produtos, comparar vendedores, entender informações de QC, avaliar opções de envio e tomar decisões de compra mais informadas com o CSSBuy Spreadsheet.",
  "hero.cta.primary": "Explorar CSSBuy Spreadsheet",
  "hero.cta.secondary": "Ver o Guia Completo",
  "hero.trust": "Guias independentes • Comparações práticas • Recursos atualizados",
  "categories.title": "Categorias de Produtos",
  "categories.subtitle": "Selecione uma categoria para explorar produtos no CSSBuy Spreadsheet",
  "categories.dropdown.placeholder": "Selecione uma categoria...",
  "cta.mainSite": "CSSBuy Spreadsheet",
  "cta.buyNow": "Buy It Now",
  "cta.explore": "Explorar todos os recursos CSSBuy",
  "intro.title": "O que é o CSSBuy Spreadsheet?",
  "intro.text": "O CSSBuy Spreadsheet é uma forma prática de organizar informações sobre produtos, vendedores, preços, categorias e recursos de pesquisa antes de realizar uma compra. Ele ajuda você a comparar diferentes opções de forma mais organizada e encontrar informações relevantes com mais rapidez.",
  "resources.title": "Encontre informações importantes em um só lugar",
  "resources.products": "Produtos",
  "resources.products.desc": "Pesquise e organize produtos por categoria.",
  "resources.sellers": "Vendedores",
  "resources.sellers.desc": "Compare vendedores e informações disponíveis.",
  "resources.qc": "QC",
  "resources.qc.desc": "Entenda como analisar fotos e informações de qualidade.",
  "resources.shipping": "Shipping",
  "resources.shipping.desc": "Compare métodos e custos de envio.",
  "resources.warehouse": "Warehouse",
  "resources.warehouse.desc": "Entenda o processo de armazenamento e preparação.",
  "resources.safety": "Segurança",
  "resources.safety.desc": "Aprenda a identificar riscos e informações duvidosas.",
  "compare.title": "Compare antes de comprar",
  "compare.factor": "Fator",
  "compare.check": "O que verificar",
  "compare.why": "Por que importa",
  "compare.product": "Produto",
  "compare.product.check": "Descrição e variantes",
  "compare.product.why": "Evita erros",
  "compare.seller": "Vendedor",
  "compare.seller.check": "Histórico e avaliações",
  "compare.seller.why": "Ajuda na pesquisa",
  "compare.qc": "QC",
  "compare.qc.check": "Fotos disponíveis",
  "compare.qc.why": "Permite verificar detalhes",
  "compare.price": "Preço",
  "compare.price.check": "Diferentes opções",
  "compare.price.why": "Facilita comparação",
  "compare.shipping": "Shipping",
  "compare.shipping.check": "Método e custo",
  "compare.shipping.why": "Ajuda no planejamento",
  "articles.title": "Artigos e Guias",
  "articles.subtitle": "Conteúdo original e atualizado sobre CSSBuy Spreadsheet",
  "articles.readMore": "Ler artigo completo",
  "footer.disclaimer": "Este site é um recurso informativo independente. Não é o site oficial da CSSBuy, salvo quando indicado explicitamente.",
  "footer.copyright": "© 2026 CSSBuyBR Guru. Todos os direitos reservados.",
  "footer.about": "Sobre",
  "footer.contact": "Contato",
  "footer.privacy": "Privacidade",
  "footer.terms": "Termos",
  "footer.disclaimerLink": "Aviso Legal",
  "footer.safety": "Centro de Segurança",
  "footer.editorial": "Política Editorial",
  "seo.homeTitle": "CSSBuy Spreadsheet: Guia Completo de Produtos e Vendedores 2026",
  "seo.homeDesc": "CSSBuy Spreadsheet recurso independente. Encontre produtos, compare vendedores, entenda QC, envio e warehouse. Guias práticas e atualizadas.",
  "article.published": "Publicado",
  "article.updated": "Atualizado",
  "article.author": "Equipe CSSBuyBR",
  "article.breadcrumbHome": "Início",
  "article.related": "Artigos Relacionados",
  "article.toc": "Conteúdo",
  "article.quickAnswer": "Resposta Rápida",
  "safety.notice": "Este site é um recurso informativo independente. Não é o site oficial da CSSBuy, salvo quando indicado explicitamente. Verifique sempre preços, políticas, vendedores, links, métodos de pagamento e condições de envio antes de realizar uma compra.",
  "notFound.title": "Página não encontrada",
  "notFound.back": "Voltar para Início",
  "schema.orgName": "CSSBuyBR Guru",
  "schema.orgDesc": "Recurso independente para CSSBuy Spreadsheet, produtos, vendedores e guias de compra"
};

export default ptTranslations;